import { render, staticRenderFns } from "./channelAdPlanDetail.vue?vue&type=template&id=49795d1a&scoped=true&"
import script from "./channelAdPlanDetail.vue?vue&type=script&lang=js&"
export * from "./channelAdPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./channelAdPlanDetail.vue?vue&type=style&index=0&id=49795d1a&lang=scss&scoped=true&"
import style1 from "./channelAdPlanDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49795d1a",
  null
  
)

export default component.exports